define('lq/imageSize',[],function() {
    'use strict';

    var hasHighPixelRatio = function () {
        // e.g. high-resolution and retina displays
        return window.devicePixelRatio >= 2;
    };

    var forElement = function(htmlElementSize) {
        if (hasHighPixelRatio()) {
            return {
                x: htmlElementSize.x * 2,
                y: htmlElementSize.y * 2
            };
        }

        return {
            x: htmlElementSize.x,
            y: htmlElementSize.y
        };
    };

    return {

        hasHighPixelRatio: hasHighPixelRatio,

        forElement: forElement

    };

});
